import { render, staticRenderFns } from "./ContentMore.vue?vue&type=template&id=d12572ae&scoped=true&"
import script from "./ContentMore.vue?vue&type=script&lang=ts&"
export * from "./ContentMore.vue?vue&type=script&lang=ts&"
import style0 from "./ContentMore.vue?vue&type=style&index=0&id=d12572ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12572ae",
  null
  
)

export default component.exports